"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _helpers = require("./helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GridCell = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(GridCell, _React$PureComponent);

  var _super = _createSuper(GridCell);

  function GridCell() {
    var _this;

    _classCallCheck(this, GridCell);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "parseHtmlContent", function (html) {
      return String(html).replace(/<\/?[^>]+>/g, '');
    });

    _defineProperty(_assertThisInitialized(_this), "displayCell", function (value, item, data) {
      var _this$props = _this.props,
          t = _this$props.t,
          firstField = _this$props.firstField,
          name = _this$props.name,
          elementIconClass = _this$props.elementIconClass,
          folderIconClass = _this$props.folderIconClass;
      var showTreeIcon = data.tree && name === firstField;

      if (item.link && typeof item.link === 'function') {
        return /*#__PURE__*/_react["default"].createElement("a", {
          className: "data-cell",
          href: item.link(data)
        }, value);
      } else if (item.html) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "data-cell",
          title: _this.parseHtmlContent(value),
          dangerouslySetInnerHTML: {
            __html: value
          }
        });
      } else if (item.value) {
        var itemValue = item.value(data, value);

        var itemValueType = _typeof(itemValue);

        if (!['number', 'string', 'object'].includes(itemValueType)) {
          console.error("\n                    Error in column ".concat(name, ": \"Wrong column type: ").concat(itemValueType, ", expected string or number as type\".\n                    Use render props as advanced functionality for such case\n                "));
          return null;
        }

        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "data-cell",
          title: itemValue
        }, itemValue);
      } else if (item.render) {
        return item.render(data, value);
      } else if (item.component) {
        return /*#__PURE__*/_react["default"].createElement(item.component, _extends({}, item.props, {
          data: data,
          value: value,
          t: t
        }));
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "data-cell",
        title: value
      }, showTreeIcon && /*#__PURE__*/_react["default"].createElement("i", {
        className: "".concat(data.children ? folderIconClass : elementIconClass, " ").concat(data.opened ? 'opened' : '')
      }), value);
    });

    _defineProperty(_assertThisInitialized(_this), "getDelimiter", function (data) {
      var spans = [];

      if (data.level) {
        for (var i = 0; i < data.level - 1; i++) {
          var delimiter = data.delimiter[i + 1] && /*#__PURE__*/_react["default"].createElement("span", {
            key: i,
            className: "tree-delimiter",
            style: {
              left: "".concat((i + 2) * 20, "px")
            }
          });

          if (delimiter) spans.push(delimiter);
        }
      }

      return spans;
    });

    _defineProperty(_assertThisInitialized(_this), "handleToggleRowVisibility", function (e) {
      var toggleRowVisibility = _this.props.toggleRowVisibility;

      if (toggleRowVisibility && typeof toggleRowVisibility === 'function') {
        toggleRowVisibility(e, _this.props.data);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props2 = _this.props,
          data = _this$props2.data,
          item = _this$props2.item,
          value = _this$props2.value,
          forceWidth = _this$props2.forceWidth,
          name = _this$props2.name,
          lastField = _this$props2.lastField,
          resizing = _this$props2.resizing,
          firstField = _this$props2.firstField,
          fixedWidth = _this$props2.fixedWidth;
      var hidden = item.hidden,
          classWidth = item.classWidth,
          width = item.width;
      if (hidden) return null; // make td className

      var mainClass = name !== lastField && classWidth ? classWidth : '';
      var firstTreeCell = data.tree && name === firstField;
      var tdClassName = (0, _classnames["default"])("grid-cell-".concat(mainClass), {
        resizing: resizing,
        'tree-cell': firstTreeCell
      }); // make td styles

      var forcedWidthStyle = (0, _helpers.getWidthStyles)(forceWidth || fixedWidth || width);
      var levelStyle = firstTreeCell ? {
        paddingLeft: "".concat((data.level + 1) * 20, "px")
      } : null;
      var styles = forcedWidthStyle || levelStyle ? _objectSpread(_objectSpread({}, forcedWidthStyle), levelStyle) : undefined; // make div className

      var firstParentCell = data.children && name === firstField;
      var divClassName = (0, _classnames["default"])('item-cell', {
        parent: firstParentCell,
        first: data.firstChild,
        last: data.lastChild,
        level: data.level
      });
      return /*#__PURE__*/_react["default"].createElement("td", {
        className: tdClassName,
        style: styles,
        "data-name": name
      }, firstTreeCell && data.level > 1 && _this.getDelimiter(data).map(function (el) {
        return el;
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: divClassName
      }, firstParentCell && /*#__PURE__*/_react["default"].createElement("div", {
        className: "plus-cell-checkbox",
        onClick: _this.handleToggleRowVisibility
      }, data.children && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('plus-label', {
          opened: data.opened
        })
      })), _this.displayCell(value, item, data)));
    });

    return _this;
  }

  return _createClass(GridCell);
}(_react["default"].PureComponent);

exports["default"] = GridCell;
GridCell.defaultProps = {
  folderIconClass: 'icon-folder',
  elementIconClass: 'icon-tasks'
};
GridCell.propTypes = {
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].bool, _propTypes["default"].object]),
  data: _propTypes["default"].object,
  item: _propTypes["default"].object,
  name: _propTypes["default"].string,
  lastField: _propTypes["default"].string,
  firstField: _propTypes["default"].string,
  forceWidth: _propTypes["default"].number,
  toggleRowVisibility: _propTypes["default"].func,
  resizing: _propTypes["default"].bool,
  folderIconClass: _propTypes["default"].string,
  elementIconClass: _propTypes["default"].string
};